import _ from "lodash";
import { isValidElement, memo, useEffect, useState } from "react"
import { Controller, useFormContext } from "react-hook-form";

const weekDays = ["شنبه", "یکشنبه", "دوشنبه", "سه شنبه", "چهارشنبه", "پنج شنبه", "جمعه"];
const monthNames = ["فروردین", "اردیبهشت", "خرداد", "تیر", "مرداد", "شهریور", "مهر", "آبان", "آذر", "دی", "بهمن", "اسفند"];


const CreateAllDates = ({ dates, setPeriodDatesFilters }) => {
  const [weeks, setWeeks] = useState([])
  const methods = useFormContext()
  useEffect(() => {
    const weeksVar = []
    let currentWeek = new Array(7).fill(null);
    let prevDayIndex = -1;
    let prevMonth = null;

    dates.forEach((date, idx) => {
      const nameDate = date.year + date.month + date.day;
      const dayIndex = weekDays.indexOf(date.persianDayOfWeek);
      const monthIndex = _.toInteger(date.month) - 1;
      const monthLabel = `${monthNames[monthIndex]} ${date.year}`;

      if (prevMonth !== monthLabel) {
        if (currentWeek.some(Boolean)) {
          weeksVar.push(currentWeek);
          currentWeek = new Array(7).fill(null);
          prevDayIndex = -1;
        }

        // اضافه کردن فقط نام ماه (در بیرون جدول)
        weeksVar.push(
          <tr key={`month-${monthLabel}`}>
            <td colSpan={7} style={{ padding: "0.75rem", background: "#e9ecef", fontWeight: "bold" }}>
              {monthLabel}
            </td>
          </tr>,
        );

        // اضافه کردن عنوان روزهای هفته
        weeksVar.push(
          <tr key={`weekdays-${monthLabel}`} className="bg-light">
            {weekDays.map((day) => (
              <th className="text-small px-0 py-2" key={day}>
                {day}
              </th>
            ))}
          </tr>,
        );

        prevMonth = monthLabel;
      }

      if (dayIndex <= prevDayIndex) {
        weeksVar.push(currentWeek);
        currentWeek = new Array(7).fill(null);
        prevDayIndex = -1;
      }

      currentWeek[dayIndex] = (
        <td key={`td-${nameDate}`} style={{ fontSize: "0.9rem" }}>
          <label className="mb-0" style={{ whiteSpace: "nowrap" }}>
            <Controller
              key={`d_${nameDate}`}
              name={`d_${nameDate}`}
              render={({ field }) =>
                <input
                  type="checkbox"
                  style={{ margin: "0 5px" }}
                  title="فعال/غیرفعال"
                  onChange={(e) => {
                    if (!e.target.checked) {
                      methods.setValue("filter_AllDays", false);
                      switch (date.persianDayOfWeek) {
                        case "شنبه":
                          methods.setValue(`filter_Saturday`, false);
                          setPeriodDatesFilters((prev) => ({
                            ...prev,
                            saturday: null,
                            allDays: false,
                          }));
                          break;
                        case "یکشنبه":
                          methods.setValue(`filter_Sunday`, false);
                          setPeriodDatesFilters((prev) => ({
                            ...prev,
                            sunday: null,
                            allDays: false,
                          }));
                          break;
                        case "دوشنبه":
                          methods.setValue(`filter_Monday`, false);
                          setPeriodDatesFilters((prev) => ({
                            ...prev,
                            monday: null,
                            allDays: false,
                          }));
                          break;
                        case "سه شنبه":
                          methods.setValue(`filter_Tuesday`, false);
                          setPeriodDatesFilters((prev) => ({
                            ...prev,
                            tuesday: null,
                            allDays: false,
                          }));
                          break;
                        case "چهارشنبه":
                          methods.setValue(`filter_Wednesday`, false);
                          setPeriodDatesFilters((prev) => ({
                            ...prev,
                            wednesday: null,
                            allDays: false,
                          }));
                          break;
                        case "پنج شنبه":
                          methods.setValue(`filter_Thursday`, false);
                          setPeriodDatesFilters((prev) => ({
                            ...prev,
                            thursday: null,
                            allDays: false,
                          }));
                          break;
                        case "جمعه":
                          methods.setValue(`filter_Friday`, false);
                          setPeriodDatesFilters((prev) => ({
                            ...prev,
                            friday: null,
                            allDays: false,
                          }));
                          break;
                      }
                    }
                    field.onChange(e.target.checked)
                  }}
                  checked={field.value}
                />
              }
            />

            {date.date}
          </label>
        </td>
      );

      prevDayIndex = dayIndex;

      if (dayIndex === 6) {
        weeksVar.push(currentWeek);
        currentWeek = new Array(7).fill(null);
        prevDayIndex = -1;
      }
    });

    if (currentWeek.some((cell) => cell !== null)) {
      weeksVar.push(currentWeek);
    }

    setWeeks(weeksVar)
  }, [dates])

  return (
    <div className="table-responsive p-0 rounded-3" style={{ border: "1px solid #a2a6b9" }}>
      <table className="table table-bordered text-center">
        <tbody>
          {weeks.map((row, i) =>
            isValidElement(row) ? (
              row
            ) : (
              <tr className="user-select-none" key={`week-${i}`}>{row.map((cell, j) => cell || <td key={`empty-${i}-${j}`} />)}</tr>
            ),
          )}
        </tbody>
      </table>
    </div>
  )
}

export default memo(CreateAllDates)